// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import MenuActiveManager from './MenuActiveManager';
import menuItem from 'menu-items';
import { getRotas } from 'services/auth';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const rotas = JSON.parse(getRotas());
    const pages = {
        id: 'pages',
        title: 'Páginas',
        // caption: 'Pages Caption',
        type: 'group',
        children: rotas
    }
    menuItem.items[1] = pages;

    const navItems = menuItem.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <MenuActiveManager />
            {navItems}
        </>
    );
};

export default MenuList;
